import { render, staticRenderFns } from "./CompCreate.vue?vue&type=template&id=4e0caedc&scoped=true"
import script from "./CompCreate.vue?vue&type=script&lang=js"
export * from "./CompCreate.vue?vue&type=script&lang=js"
import style0 from "./CompCreate.vue?vue&type=style&index=0&id=4e0caedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0caedc",
  null
  
)

export default component.exports